import { useDisclosure } from '@mantine/hooks';
import { Drawer, Burger, useMatches } from '@mantine/core';
import { navLinks } from './Header';

const SideBar=()=> {
  const [opened, { toggle }] = useDisclosure(false);
  const size=useMatches({
   xs:'md',
   sm:'lg'
});

  return (
    <>
      <Drawer.Root  className='sm:hidden !-z-0'  position='right' opened={opened}   onClose={toggle} size="50vw" >
        <Drawer.Overlay className='!-z-1 !backdrop-filter-85 blur-sm' />
        <Drawer.Content className='!z-2' bg="#0A0A0A">
          <Drawer.Body className='mt-20 xs:mt-24  flex flex-col gap-5 ' bg="#0A0A0A"data-aos="fade-left" data-aos-duration="800">
            {navLinks(true, toggle)}
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Root>

      <Burger  className='bs:!hidden !z-50 relative' size={size} color='#64FFDA' opened={opened} onClick={toggle}data-aos="fade-down" data-aos-duration="1000"  />
    </>
  );
}
export default SideBar;